import styled from 'styled-components'

export const StyledLogoAnimation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`
